// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---packages-suzis-theme-src-pages-index-tsx": () => import("C:\\Users\\Spankin\\Repos\\SuzisSpecialties\\packages\\suzis-theme\\src\\pages\\index.tsx" /* webpackChunkName: "component---packages-suzis-theme-src-pages-index-tsx" */)
}

